module.exports = __webpack_public_path__ + "static/img/ft-wx.b786ac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ft-wx.jpg
// module id = waAV
// module chunks = 0